import React, { useCallback } from 'react';
import { useSelect, useSelectWithParams } from '../../../../../../utils/selector.utils';
import { wrikeFolderMeetingSelectors } from '../../../../../../app/resource/wrike-folder-meeting/wrike-folder-meeting.selectors';
import { wrikeFolderSelectors } from '../../../../../../app/resource/wrike-folder/wrike-folder.selectors';
import { IMeetingSimple } from '../../../../../../app/resource/meeting-simple/meeting-simple.types';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../../app/dialog/dialog.actions';
import { settingsSelectors } from '../../../../../../app/resource/settings/settings.selectors';
import { authSelectors } from '../../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../../app/resource/user/user.selectors';

export const WrikeFolderTab = ({ meetingId }: { meetingId: IMeetingSimple['id'] }) => {
  const dispatch = useDispatch();
  const userId = useSelect(authSelectors.selectLoggedUser);
  const user = useSelectWithParams(userSelectors.selectResourceById, userId ? userId : '');
  const wrikeFolderMeetings = useSelect(wrikeFolderMeetingSelectors.selectResourceList);
  const wrikeRemoteFolders = useSelect(wrikeFolderSelectors.selectResourceList);
  const wrikeFolderMeeting = wrikeFolderMeetings.find((meeting) => meeting.meetingId === meetingId);
  const settings = useSelectWithParams(settingsSelectors.selectResourceById, user?.tenantId ? user.tenantId : '');
  const wrikeFolderMeetingAssociation = wrikeFolderMeeting
    ? wrikeRemoteFolders.find((folder) => folder.id === wrikeFolderMeeting.wrikeFolderId)
    : null;

  const handleOpenWrikeFoldersDialog = useCallback(() => {
    dispatch(openDialog('wrikeFoldersDialog', { meetingId }));
  }, [dispatch, meetingId]);
  return (
    <>
      {settings?.wrikeWorkspaceName && (
        <div
          className="flex aic ml-auto pr-2"
          style={{ color: '#66717c', overflow: 'hidden', textOverflow: 'ellipsis', width: 'fit-content' }}
        >
          <a
            className="btn btn-md f-14 mx-0 white-bg px-2 popup_button border-2x py-0"
            title="Wrike"
            onClick={handleOpenWrikeFoldersDialog}
          >
            <img alt="Wrike" className="mr-1" height="20" width="20" src="https://www.wrike.com/favicon.ico" />
            {wrikeFolderMeetingAssociation ? (
              <>
                Connected to &quot;
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                    maxWidth: '170px',
                    verticalAlign: 'bottom',
                  }}
                >
                  {wrikeFolderMeetingAssociation.title}
                </span>
                &quot;
              </>
            ) : (
              'Not Connected'
            )}
          </a>
        </div>
      )}
    </>
  );
};
